export const ARTICLE_PAGE_SIZE = 3;
export const PLACEHOLDER_CARDS_NUM = 3;
